/** Cada cuántos ms se consultan las notificaciones no leídas (polling). Default 30s. */
export const NOTIF_POLL_INTERVAL_MS =
  Number(process.env.REACT_APP_NOTIF_POLL_INTERVAL_MS) || 30000;
